<script setup lang="ts">
import useTracking from "@citizenm/lobby/composables/useTracking";

const { t } = useI18n();
const localePath = useLocalePath();
const { trackMainNavi } = useTracking();

const emit = defineEmits<{
  (e: "logout"): void;
}>();
</script>

<template>
  <ul>
    <li>
      <NuxtLink
        active-class="logged-in-menu__link--active"
        class="logged-in-menu__link"
        :to="localePath('/my/dashboard')"
        @click="trackMainNavi(t('website.navigation.logged_in.dashboard'))"
      >
        {{ t("website.navigation.logged_in.dashboard") }}
      </NuxtLink>
    </li>

    <li>
      <NuxtLink
        active-class="logged-in-menu__link--active"
        class="logged-in-menu__link"
        :to="localePath('/my/reservations')"
        @click="trackMainNavi(t('website.navigation.logged_in.hotel_stays'))"
      >
        {{ t("website.navigation.logged_in.hotel_stays") }}
      </NuxtLink>
    </li>
    <li>
      <NuxtLink
        active-class="logged-in-menu__link--active"
        class="logged-in-menu__link"
        :to="localePath('/my/profile')"
        @click="trackMainNavi(t('website.navigation.logged_in.my_profile'))"
      >
        {{ t("website.navigation.logged_in.my_profile") }}
      </NuxtLink>
    </li>
    <li>
      <NuxtLink
        active-class="logged-in-menu__link--active"
        class="logged-in-menu__link"
        :to="localePath('/my/membership')"
        @click="trackMainNavi(t('website.navigation.logged_in.membership'))"
      >
        {{ t("website.navigation.logged_in.membership") }}
      </NuxtLink>
    </li>
    <li class="logged-in-menu__separator">
      <button
        class="logged-in-menu__link"
        @click="
          () => {
            trackMainNavi(t('website.navigation.logged_in.log_out'));
            emit('logout');
          }
        "
      >
        {{ t("website.navigation.logged_in.log_out") }}
      </button>
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use "@citizenm/foundation/assets/styles/mixins" as mixins;
@include mixins.reset-list;

.logged-in-menu {
  &__separator {
    @include mixins.lg {
      margin-block-start: var(--cm-spacing-4, 1rem);
      padding-block-start: var(--cm-spacing-4, 1rem);
      border-top: 1px solid var(--primary-light-gray, #f2f2f2);
    }
  }

  &__link {
    font-weight: bold;
    line-height: 3;
    text-decoration: none;

    @include mixins.lg {
      font-size: 0.875rem;
      line-height: 2.1;
    }

    &:hover {
      color: var(--primary-red, #ff0038);
    }
  }
}
</style>
